import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Typography, Icon, Tooltip} from 'antd'
import {getLocalData} from "../../../../services/StorageServices"

const {Paragraph} = Typography

class ColActions extends Component {
    render() {
        const {code, partnerURL} = this.props
        const accessToken = getLocalData('accessToken')
        const refreshToken = getLocalData('refreshToken')
        const url = [
            `${partnerURL}/${code}`,
            [accessToken && `token=${accessToken}`, refreshToken && `refresh_token=${refreshToken}`].filter(Boolean).join('&')
        ].filter(Boolean).join('?')

        return <td className="colActions">
            <div className="d-flex align-items-center">
                <Paragraph copyable={{text: url}} className='mb-0 ml-0'/>
                <div className='viewPartner Icon ml-3 cursor-pointer' onClick={() => window.open(url, "_blank")}>
                    <Tooltip placement="top" title="Xem">
                        <Icon className="text-success" type="eye"/>
                    </Tooltip>
                </div>
            </div>
        </td>
    }
}

ColActions.propTypes = {
    code: PropTypes.string.isRequired,
    partnerURL: PropTypes.string,
}

export default ColActions